import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ValidIcon, DeleteIcon, PreviewIcon } from '@parchment/icons';
import { apple, java, mineShaft, white, willowBrook } from '@parchment/atoms';
import { SCALE } from '../../utils/constants';
const ROOT_SIZE = {
  small: '100px',
  medium: '130px',
  large: '250px'
};
const ROOT_BORDER = {
  small: '5px',
  medium: '8px',
  large: '10px'
};
const ROOT_FONT = {
  small: '16px',
  medium: '20px',
  large: '24px'
};
const ICON_SIZE = {
  small: 'width: 35px; height: 35px;',
  medium: 'width: 50px; height: 50px;',
  large: 'width: 60px; height: 60px;'
};
const ICON_FONT = {
  small: '20px',
  medium: '24px',
  large: '30px'
};
export default function FileCard(props) {
  const [scale, setScale] = useState(props.scale || SCALE.medium);
  useEffect(() => setScale(props.scale || SCALE.medium), [props.scale]);
  return /*#__PURE__*/React.createElement(Root, {
    scale: scale
  }, /*#__PURE__*/React.createElement(FileNameContainer, null, /*#__PURE__*/React.createElement(SuccessIcon, {
    color: apple
  }), /*#__PURE__*/React.createElement(FileName, null, props.fileName)), /*#__PURE__*/React.createElement(IconContainer, null, props.allowPreview && /*#__PURE__*/React.createElement(ButtonWrapper, {
    type: "button",
    "aria-label": "preview",
    onClick: () => props.onPreviewClick && props.onPreviewClick(props.fileName),
    scale: scale
  }, /*#__PURE__*/React.createElement(StyledPreviewIcon, {
    color: java
  })), props.allowDelete && /*#__PURE__*/React.createElement(ButtonWrapper, {
    type: "button",
    "aria-label": "delete",
    onClick: () => props.onDeleteClick && props.onDeleteClick(props.fileName),
    scale: scale
  }, /*#__PURE__*/React.createElement(StyledDeleteIcon, {
    color: java
  }))));
}
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "FileCard__Root",
  componentId: "sc-9z64wi-0"
})(["padding:15px;min-height:", ";background-color:", ";border-left:", " solid ", ";display:flex;align-content:center;justify-content:space-between;font-size:", ";"], props => ROOT_SIZE[props.scale || SCALE.medium], willowBrook, props => ROOT_BORDER[props.scale || SCALE.medium], apple, props => ROOT_FONT[props.scale || SCALE.medium]);
const FileNameContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FileCard__FileNameContainer",
  componentId: "sc-9z64wi-1"
})(["display:inherit;overflow:hidden;text-overflow:ellipsis;"]);
const FileName = /*#__PURE__*/styled.div.withConfig({
  displayName: "FileCard__FileName",
  componentId: "sc-9z64wi-2"
})(["color:", ";font-weight:600;display:inline-block;margin:auto 0;"], mineShaft);
const SuccessIcon = /*#__PURE__*/styled(ValidIcon).withConfig({
  displayName: "FileCard__SuccessIcon",
  componentId: "sc-9z64wi-3"
})(["margin:auto 10px auto 20px;display:inline-block;top:0;overflow:initial;"]);
const IconContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FileCard__IconContainer",
  componentId: "sc-9z64wi-4"
})(["display:inherit;margin-right:30px;"]);
const StyledPreviewIcon = /*#__PURE__*/styled(PreviewIcon).withConfig({
  displayName: "FileCard__StyledPreviewIcon",
  componentId: "sc-9z64wi-5"
})(["position:initial;"]);
const StyledDeleteIcon = /*#__PURE__*/styled(DeleteIcon).withConfig({
  displayName: "FileCard__StyledDeleteIcon",
  componentId: "sc-9z64wi-6"
})(["position:initial;"]);
const ButtonWrapper = /*#__PURE__*/styled.button.withConfig({
  displayName: "FileCard__ButtonWrapper",
  componentId: "sc-9z64wi-7"
})(["", ";font-size:", ";margin:auto;display:flex;justify-content:center;align-items:center;background-color:unset;border:none;border-radius:100%;cursor:pointer;&:hover svg{color:", "}&:hover{background:", ";}"], props => ICON_SIZE[props.scale || SCALE.medium], props => ICON_FONT[props.scale || SCALE.medium], white, java);